import { faDatabase } from "@fortawesome/pro-light-svg-icons";
import { faCalendar, faGear, faMessageLines, faRss, faUser } from "@fortawesome/pro-regular-svg-icons";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ApplicationContext } from "../contexts/ApplicationContext";
import { AuthenticatedUserContext } from "../contexts/AuthenticatedUserContext";
import { useViewport } from "./useViewport";

export interface NavItem {
  title: string;
  url?: string;
  icon?: any;
  active: boolean;
  showOnMenu: boolean;
  badge?: number | null;
  desktop: boolean;
  mobile: boolean;
}

export const NavItems = () => {
  const path = window.location.pathname;
  const { member } = useContext(AuthenticatedUserContext);
  const { application } = useContext(ApplicationContext);
  const { isMobile } = useViewport();
  // @ts-ignore
  const isAdmin = member?.is_admin;
  const { t } = useTranslation();

  let navItems: NavItem[] = [];

  // all items
  application.chat_enabled &&
    navItems.push({
      desktop: true,
      mobile: true,
      title: t("chat"),
      showOnMenu: true,
      url: isMobile ? "/mchat" : "/chat",
      icon: faMessageLines,
      active: path.startsWith("/chat") || path.startsWith("/mchat"),
    });
  application.news_enabled && navItems.push({ desktop: true, mobile: true, title: t("latest"), showOnMenu: true, url: "/news", icon: faRss, active: path.startsWith("/news") });
  application.events_enabled && navItems.push({ desktop: true, mobile: true, title: t("calendar"), showOnMenu: true, url: "/events", icon: faCalendar, active: path.startsWith("/events") });
  application.resources_enabled &&
    navItems.push({ desktop: true, mobile: true, title: t("drive"), showOnMenu: true, url: "/resources", icon: faDatabase, active: path.startsWith("/resources") || path.startsWith("/files") });
  application.profile_enabled &&
    navItems.push({
      title: "Profile",
      showOnMenu: true,
      url: "/profile",
      icon: faUser,
      desktop: false,
      mobile: true,
      active: path.startsWith("/profile") || path.startsWith("/contact") || path.startsWith("/account") || path.startsWith("/my-files"),
    });

  if (isAdmin) {
    navItems.push({ desktop: true, mobile: false, title: "Settings", showOnMenu: true, url: "/admin/settings", icon: faGear, active: path === "/admin/settings" });
    navItems.push({ desktop: true, mobile: false, title: "Admin", showOnMenu: true, url: "/admin/panel", icon: faDatabase, active: path === "/admin/panel" });
  }

  return navItems;
};
